/**
 * description:
 * author: 1580043700@qq.com
 * create_date: 2023/11/11-15:34
 */

const config = {
  rowSelection: true,
  fieldControl: false,
  // listTitle: '开发商列表',
  searchMode: "group",
  columns: [
    {
      title: '开发商名称',
      dataIndex: 'name',
      width: 150,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 150,
    },
    {
      title: '修改时间',
      dataIndex: 'lastUpdatedTime',
      itemType: 'dateTime',
      width: 150,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 100,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'name',
      label: '开发商名称',
      addonOpts: [],
    },
  ],
  footer: [
    {
      label: '新增',
      // auth: 'EstateButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [
    {
      label: '批量删除',
      // auth: 'EstateButton3',
      events: ['onClick:onDel'],
      status: ['loading:reloadLoading', 'disabled:reloadDisabled'],
    },
  ]
}

export default config
